const React = require('react');
const PropTypes = React.PropTypes; //TODO: react 15.5 -> require( 'prop-types' );

import {clickoutsideWrapper} from './ClickOutside.jsx'

class Select extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dropdownOpen: false,
        }
    }

    render() {
        let activeValue = this.props.active;
        let options = this.props.options;
        let isWrapper = !(typeof this.props.children === 'undefined');

        let callToAction = !isWrapper ? (
            <div className="option callToAction" onClick={() => this.toggleDropdown()}
                 key={this.props.callToAction}>
                {this.props.callToAction}
            </div>
        ) : (
            this.props.children.map((child, i) => {
                if (i === 0) {
                    return (
                        <div className="option callToAction" onClick={() => this.toggleDropdown()}
                             key='callToAction'>
                            {child}
                        </div>
                    )
                }
            })
        )


        let dropdownOptions;
        if (!isWrapper) {
            dropdownOptions = options.map(option => {
                let className = activeValue === option.value ? "option selected" : "option";
                return (
                    <div className={className} onClick={() => this.handleOptionClick(option.value)}
                         key={option.name}>
                        {option.name}
                    </div>
                )
            })
        } else {
            dropdownOptions = this.props.children.map((option, i) => {
                if (typeof this.props.showCallToAction !== 'undefined' && i === 0) return;
                let className = activeValue === i ? "option selected" : "option";
                return (
                    <div className={className} onClick={() => this.handleOptionClick(i)}
                         key={i}>
                        {option}
                    </div>
                )
            })
        }

        let activeOption;
        let activeOptionElement;

        if (!isWrapper) {
            activeOption = options.filter(option => {
                return activeValue === option.value
            })
            if (activeOption.length === 0 && options.length) {
                activeOption = [options[0]];
            }
            activeOptionElement = activeOption.map(option => {
                return (
                    <div className="option active"
                         key={option.name} onClick={() => this.toggleDropdown()}>
                        {option.name}
                    </div>
                )
            })
        } else {
            activeOption = this.props.children.filter((option, i) => {
                return activeValue === i
            })
            if (activeOption.length === 0 && this.props.children.length) {
                activeOption = [this.props.children[0]];
            }
            activeOptionElement = activeOption.map((option, i) => {
                return (
                    <div className="option active" key={i}
                         onClick={() => this.toggleDropdown()}>
                        {option}
                    </div>
                )
            })
        }

        let selectToggleClassName = this.state.dropdownOpen ? 'select-toggle open' : 'select-toggle';

        let dropDownStyle = {
            display: this.state.dropdownOpen?'block':'none',
        };

        let dropdown = (
            <div className="dropdown" style={dropDownStyle}>
                {dropdownOptions}
            </div>
        )

        let mySelect = <div className={"lr-components-select select" + ' ' + this.props.className}>
            <div className={selectToggleClassName} onClick={() => this.toggleDropdown()}></div>
            {this.props.showCallToAction ? callToAction : activeOptionElement}
            {dropdown}
        </div>

        return clickoutsideWrapper(mySelect, () => this.closeDropdown())
    }

    handleOptionClick(value) {
        if (this.state.dropdownOpen) {
            this.props.choiceHandler(value);
        }
        this.toggleDropdown();
    }

    toggleDropdown() {
        if (!this.state.dropdownOpen) {
            this.setState({dropdownOpen: true})
        } else {
            this.setState({dropdownOpen: false})
        }
    }

    closeDropdown() {
        if (this.state.dropdownOpen) {
            this.setState({dropdownOpen: false})
        }
    }
}

Select.propTypes = {
    active: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    options: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number
            ]).isRequired,
            value: PropTypes.isRequired

        })
    ),
    choiceHandler: PropTypes.func.isRequired,
    callToAction: PropTypes.string,
    showCallToAction: PropTypes.bool
};

module.exports = Select;


// WEBPACK FOOTER //
// ./js/caseconfigurator/components/UI/Select.jsx